import $ from 'jquery';
import { loadStateFilter } from '../../AsyncLoader';

async function register(data) {
  const StateFilter = await loadStateFilter();

  return new StateFilter(data);
}

export {
  register,
};


// WEBPACK FOOTER //
// ./V7/tnew/lib/StateFilterRegistration.js